
import React from 'react';
import { CreateMerchantAdminForm } from '../components/CreateMerchantAdminForm';

const Layout = ({ children }: { children: React.ReactNode }) => (
  <div className="min-h-screen bg-background">
    <header className="border-b">
      <div className="container mx-auto px-4 py-4">
        <h1 className="text-2xl font-bold">ProPay Simulator Admin</h1>
      </div>
    </header>
    <main className="container mx-auto px-4 py-8">
      {children}
    </main>
  </div>
);

const CreateMerchantPage = () => (
  <Layout>
    <div className="max-w-2xl mx-auto">
      <div className="mb-6">
        <a
          href="/"
          className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground mb-4"
        >
          ← Back to Home
        </a>
        <h2 className="text-2xl font-bold mb-2">Create Merchant</h2>
        <p className="text-muted-foreground">
          Create a new merchant with basic information using the simplified admin interface.
        </p>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
        <h3 className="font-medium text-blue-900 mb-2">What is a Merchant?</h3>
        <p className="text-sm text-blue-800">
          A merchant represents a business entity in the ProPay system. This creates the basic merchant record
          with essential information like name and account number.
        </p>
      </div>

      <CreateMerchantAdminForm
        onSuccess={(merchantId) => {
          console.log('Merchant created:', merchantId);
          // Navigate to merchant profiles or show success message
        }}
      />

      <div className="mt-6 p-4 bg-gray-50 rounded-lg">
        <h3 className="font-medium mb-2">Next Steps</h3>
        <p className="text-sm text-muted-foreground mb-3">
          After creating a merchant, you can:
        </p>
        <ul className="text-sm text-muted-foreground space-y-1">
          <li>• View and manage existing merchants</li>
          <li>• Test payment processing scenarios</li>
        </ul>
        <div className="mt-4">
          <a
            href="/merchants"
            className="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors border border-input bg-transparent shadow-sm hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2"
          >
            View All Merchants
          </a>
        </div>
      </div>
    </div>
  </Layout>
);

export default CreateMerchantPage;
